<template>
  <span class="tooltip pointer" @click="(event) => event.stopPropagation()">
    <span>
      <slot></slot>
    </span>
    <span v-if="data" ref="tooltip" class="message" :class="[position ? position : tooltipPosition]" v-html="data">
    </span>
  </span>
</template>

<script>
export default {
  props: [ "data", "position"],
  data() {
    return {
      tooltipPosition: 'right'
    }
  },
};
</script>
